import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    card: {
      display: "flex",
      alignItems: "center",
      gap: "24px",
      padding: "20px",
      marginTop: "20px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: "16px",
      },
    },
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
      },
    },
    leftSection: {
      display: "flex",
      flexDirection: "column",
      minWidth: 150,
      [theme.breakpoints.down("xs")]: {
        alignItems: "flex-start",
        minWidth: "100%",
      },
    },

    saleInfo: {
      display: "flex",
      alignItems: "center",
      marginTop: 4,
      [theme.breakpoints.down("xs")]: {
        justifyContent: "center",
      },
    },

    middleSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginLeft: 4,
      [theme.breakpoints.down("xs")]: {
        alignItems: "flex-start",
        minWidth: "100%",
      },
    },
    medianSizeBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: 2,
    },

    adsBox: {
      display: "flex",
      alignItems: "center",
      marginLeft: 4,
      [theme.breakpoints.down("xs")]: {
        justifyContent: "flex-start",
        marginLeft: 0,
        minWidth: "100%",
      },
    },

    priceBox: {
      display: "flex",
      alignItems: "center",
      marginLeft: 4,
      [theme.breakpoints.down("xs")]: {
        justifyContent: "flex-start",
        marginLeft: 0,
        minWidth: "100%",
      },
    },
  };
});
